import { repeat } from '@r/utils/utils.ts';
import { Item } from './item.tsx';
import { mapCartItemToStoreCartLineItem } from '../../utils/cart-utils.ts';
import type { ICartSchema } from '@r/types/zod-schemas.ts';
import type { z } from 'zod';
import { useTranslation } from 'react-i18next';

type ItemsTemplateProps = {
  cart: z.infer<typeof ICartSchema>;
  invalidProductIris: Set<string>;
};

const ItemsTemplate = ({ cart, invalidProductIris }: ItemsTemplateProps) => {
  const { t } = useTranslation();
  const items = cart?.items.map((item) => mapCartItemToStoreCartLineItem(item));

  return (
    <div>
      <div className="flex items-center pb-4">
        <h1 className="text-[2rem] leading-[2.75rem] font-semibold">{t('cart.title')}</h1>
      </div>

      <div className="space-y-5">
        {items
          ? items
              .sort((a, b) => {
                return (a.created_at ?? '') > (b.created_at ?? '') ? -1 : 1;
              })
              .map((item) => {
                return (
                  <Item
                    key={`${item.product_iri}-${item.added_at}`}
                    item={item}
                    isUnavailable={invalidProductIris.has(item.product_iri)}
                  />
                );
              })
          : repeat(5).map((i) => {
              return <div key={i} />;
            })}
      </div>
    </div>
  );
};

export { ItemsTemplate };
